/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';

/**
 * 
 * @export
 * @interface FormationSearch
 */
export interface FormationSearch {
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof FormationSearch
     */
    idstatutStage?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof FormationSearch
     */
    idstade?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof FormationSearch
     */
    idmetier?: Int32ListSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof FormationSearch
     */
    debutContrat?: DateSearch;
    /**
     * 
     * @type {number}
     * @memberof FormationSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormationSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormationSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormationSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormationSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormationSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormationSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormationSearch interface.
 */
export function instanceOfFormationSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormationSearchFromJSON(json: any): FormationSearch {
    return FormationSearchFromJSONTyped(json, false);
}

export function FormationSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormationSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idstatutStage': !exists(json, 'idstatutStage') ? undefined : Int32ListSearchFromJSON(json['idstatutStage']),
        'idstade': !exists(json, 'idstade') ? undefined : Int32ListSearchFromJSON(json['idstade']),
        'idmetier': !exists(json, 'idmetier') ? undefined : Int32ListSearchFromJSON(json['idmetier']),
        'debutContrat': !exists(json, 'debutContrat') ? undefined : DateSearchFromJSON(json['debutContrat']),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormationSearchToJSON(value?: FormationSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idstatutStage': Int32ListSearchToJSON(value.idstatutStage),
        'idstade': Int32ListSearchToJSON(value.idstade),
        'idmetier': Int32ListSearchToJSON(value.idmetier),
        'debutContrat': DateSearchToJSON(value.debutContrat),
        'idapprenant': value.idapprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

